import React from 'react';
import PropTypes from 'prop-types';
import { AlertCircle } from 'react-feather';
import DOMPurify from 'dompurify';

/**
 * Renderiza uma bolha de mensagem (usuario ou assistente)
 */
const ChatbotMessage = ({ message }) => {
  const isUser = message.role === 'user';
  const { isError } = message;

  /**
   * Converte markdown basico para HTML
   */
  const formatContent = (text) => {
    if (!text) return '';

    let html = text
      // Negrito
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      // Italico
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      // Codigo inline
      .replace(/`([^`]+)`/g, '<code>$1</code>')
      // Links
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>')
      // Quebras de linha
      .replace(/\n/g, '<br/>');

    // Listas com -
    html = html.replace(/((?:^|\n|- .+(?:<br\/>)?)+)/g, (match) => {
      const items = match.split('<br/>')
        .filter(line => line.trim().startsWith('- '))
        .map(line => `<li>${line.trim().substring(2)}</li>`)
        .join('');
      return items ? `<ul>${items}</ul>` : match;
    });

    return html;
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`chatbot-message ${isUser ? 'chatbot-message-user' : 'chatbot-message-assistant'} ${isError ? 'chatbot-message-error' : ''}`}>
      {!isUser && (
        <div className="chatbot-message-avatar">
          {isError ? <AlertCircle size={14} /> : 'P'}
        </div>
      )}
      <div className="chatbot-message-bubble">
        <div
          className="chatbot-message-content"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formatContent(message.content)) }}
        />
        <span className="chatbot-message-time">
          {formatTime(message.timestamp)}
        </span>
      </div>
    </div>
  );
};

ChatbotMessage.propTypes = {
  message: PropTypes.shape({
    role: PropTypes.string.isRequired,
    content: PropTypes.string,
    isError: PropTypes.bool,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  }).isRequired,
};

export default ChatbotMessage;
